module.exports = __webpack_public_path__ + "static/media/Mansur-Gavriel-Pink-Suede-Mules-Lyst.7c7a4e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Mansur-Gavriel-Pink-Suede-Mules-Lyst.png
// module id = 279
// module chunks = 0